import type { MouseEvent, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { isPlainLeftClick } from './mouseClicks';

type BackLink = {
  to: string;
  label: string;
  onFollow?: () => void;
};

type DiagnosticsPageProps = {
  children: ReactNode;
  title?: string;
  subtitle?: string | null;
  action?: ReactNode;
  back?: BackLink;
};

const followInstead =
  (onFollow: (() => void) | undefined) =>
  (event: MouseEvent<HTMLAnchorElement>): void => {
    if (onFollow === undefined || !isPlainLeftClick(event)) {
      return;
    }
    event.preventDefault();
    onFollow();
  };

const TRIAGE_TITLE = 'Diagnostics';
const TRIAGE_SUBTITLE = 'Triage crawl-health incidents across client accounts.';

function DiagnosticsPage({
  children,
  title = TRIAGE_TITLE,
  subtitle = TRIAGE_SUBTITLE,
  action,
  back,
}: DiagnosticsPageProps) {
  return (
    <main className="diagnostics-page">
      {back && (
        <Link to={back.to} className="diagnostics-back-link" onClick={followInstead(back.onFollow)}>
          <span aria-hidden="true">&larr;</span>
          <span className="visually-hidden">{back.label}</span>
        </Link>
      )}

      <header className="diagnostics-page-heading">
        <div>
          <h1 className="diagnostics-page-title">{title}</h1>
          {subtitle && <p className="diagnostics-page-subtitle">{subtitle}</p>}
        </div>
        {action}
      </header>

      {children}
    </main>
  );
}

export default DiagnosticsPage;
